import CourseDetailsPage from "./courseDetailsPage"

export default CourseDetailsPage;